import React from 'react';
import { CopyOutlined } from '@ant-design/icons';
import { Flex, Typography, theme } from 'antd';

import { usePrerenderUser } from '../../../../../hooks/usePrerenderUser';
import { useEvent } from '../../../../events/hooks/useEvent';
import { TOKEN_COPIED_EVENT, tokenCopiedPayload } from '../../../../events/tokenCopiedEvent';

const { Text } = Typography;

export const PRERENDER_TOKEN_LABEL = 'PRERENDER_TOKEN';

export const PrerenderTokenField = () => {
  const { token } = theme.useToken();
  const { token: prerenderToken, chargebeePlanId } = usePrerenderUser();
  const { track } = useEvent();

  const onTokenCopied = () => {
    track(TOKEN_COPIED_EVENT, tokenCopiedPayload(chargebeePlanId));
  };

  const monospaceLine = {
    fontFamily: token.fontFamilyCode,
    lineHeight: `${token.fontSizeSM * token.lineHeightSM}px`,
  };

  return (
    <Flex align="center" gap={token.paddingXS}>
      <Text
        copyable={{
          text: prerenderToken,
          icon: <CopyOutlined style={{ color: token.colorPrimary, fontSize: token.fontSizeLG }} />,
          tooltips: ['Copy token', 'Copied'],
          onCopy: onTokenCopied,
        }}
      />
      <Flex vertical>
        {/* FIXME: no exact token — the design's 10px label sits below fontSizeSM (12px). */}
        <Text type="secondary" style={{ ...monospaceLine, fontSize: 10 }}>
          {PRERENDER_TOKEN_LABEL}
        </Text>
        <Text style={{ ...monospaceLine, fontSize: token.fontSizeSM }}>{prerenderToken}</Text>
      </Flex>
    </Flex>
  );
};
